import CryptoJS from 'crypto-js'
const CHANNEL_ID = process.env.VUE_APP_CHANNEL_ID
const tokenParams = {
  ChannelToken: CHANNEL_ID,
  MemberId: '',
  AppVer: '',
  Os: '',
  TimeStamp: null,
}

/**
 * @param {String} memberId - userID
 * @param {String} appVer - app版本號
 * @param {String} os - 裝置OS
 * @param {Function} getTokenAPICallback - getTokenInfo api function
 */
export async function getTokenInfo(memberId, appVer, os, getTokenAPICallback) {
  if (!memberId || !appVer || !os) return 'params error'
  tokenParams.MemberId = memberId
  tokenParams.AppVer = appVer
  tokenParams.Os = os
  tokenParams.TimeStamp = Date.now()

  const checkSum = genCheckSum(tokenParams)
  const tokenRes = await getTokenAPICallback(tokenParams, checkSum)
  return tokenRes
}

/**
 * @param {Object} data - 產checkSum用的data
 * @return {string} checkSum
 */
export function genCheckSum(data) {
  const jsonStr = JSON.stringify(data).toUpperCase()
  const main = convertToAES(data.TimeStamp)
  const aesIv = main.substr(0, 16)
  const asekey = main
  const srcs = CryptoJS.enc.Utf8.parse(jsonStr)
  const iv = CryptoJS.enc.Utf8.parse(aesIv)
  const key = CryptoJS.enc.Utf8.parse(asekey)
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })

  return encrypted.toString()
}

/**
 * @param {TimeStamp} TimeStamp - 原始timeStamp
 * @return {string} TimeStamp組成的加密字串
 */
function convertToAES(TimeStamp) {
  const timeStampStr = String(TimeStamp) + String(TimeStamp)
  let result = ''

  for (let i = 0; i < timeStampStr.length; i++) {
    result += String(Math.pow(Number(timeStampStr[i]), 2))
  }
  if (result.length < 32) {
    result = padRight(result, 32, '0')
  } else {
    result = result.substr(0, 32)
  }

  return result
}

/**
 * @param {String} str - 原始字串
 * @param {String} length - 補完的長度
 * @param {String} padStr - 用來補位的字串
 * @return {string} 向右補完長度的字串
 */
function padRight(str, length, padStr) {
  if (str.length >= length) return str
  else return padRight(str + padStr, length, padStr)
}
